<lib-ph-bhp-manage-sop *ngIf="viewType !='view'" [sopId]="sopId" [institutions]="appConfig.institutions"
                       [sopVersionNo]="versionNo" [userData]="appConfig.userData"
                       (childData)="childData($event)"></lib-ph-bhp-manage-sop>
<lib-ph-bhp-view-sop *ngIf="viewType =='view'" [sopId]="sopId" [viewType]="viewType" [sopVersionNo]="versionNo"
                     [userData]="appConfig.userData" (childData)="childData($event)"></lib-ph-bhp-view-sop>
